import styled from 'styled-components'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'
import { H2, H4, H5, H6, Body1 as BodyText } from '@components/Text'

export const Wrapper = styled.section`
  padding: 91px 0 72px;
  background-color: var(--white);

  @media (min-width: ${getBreakpoint('xl')}px) {
    background: var(--white);
    padding: 96px 0;
  }
`

export const Title = styled(H2)`
  font-weight: 900;
  line-height: 37px;
  color: var(--primary-text);

  span {
    color: var(--sao-paulo-60);
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    text-align: center;
    line-height: 48px;
  }
`

export const Subtitle = styled(H4)`
  font-weight: 300;
  line-height: 23px;
  margin: 16px 0 0;
  color: var(--secondary-text);

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 4px 0 0;
    text-align: center;
    font-size: 20px;
    line-height: 24px;
  }
`

export const CardWrapper = styled.section`
  display: flex;
  margin-left: 20px;
  margin-top: 32px;
  overflow-x: scroll;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 936px;
    margin: 60px auto 0;
    overflow-x: inherit;
  }
`

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px;
  background: var(--white);
  border: 1px solid var(--vila-olimpia-20);
  border-radius: 16px;
  margin-right: 24px;
  min-width: 288px;
  height: 385px;
  box-shadow: 0px 1px 16px rgba(0, 0, 0, 0.06);
`

export const CardIcon = styled(Image)`
  width: 80px;
  height: 80px;
`

export const CardTitle = styled(H4)`
  font-weight: 700;
  line-height: 24px;
  color: var(--primary-text);
  margin: 8px 0 0;
`

export const CardSubtitle = styled(H6)`
  font-weight: 300;
  line-height: 18px;
  color: var(--primary-text);
  margin: 8px 0 0;
`

export const PriceWrapper = styled.section`
  display: flex;
  align-items: baseline;
  margin: 32px 0 32px;
`

export const Price = styled.p`
  font-weight: 900;
  font-size: 48px;
  line-height: 58px;
  margin: 0 8px;
  color: var(--primary-text);
`

export const PriceCurrency = styled(H5)`
  font-weight: 500;
  line-height: 16px;
  color: var(--primary-text);
`

export const PriceHelper = styled(BodyText)`
  font-weight: 300;
  line-height: 16px;
  color: var(--primary-text);
`

export const PriceDescription = styled(H4)`
  font-weight: 700;
  line-height: 23px;
  color: var(--primary-text);
  margin: 56px 0 44px;
`

export const Body1 = styled(H5)`
  font-weight: 300;
  line-height: 24px;
  margin-top: 70px;
  text-align: center;
  color: var(--primary-text);
`

export const LargeCompaniesLink = styled.a`
  width: 100%;
`
